import Vue from 'vue'
import Vuex from 'vuex'
import { set } from 'lodash'
import VueContentPlaceholders from 'vue-content-placeholders'

import footer from './store/testdata/translate.footer'
import header from './store/testdata/translate.header'
import ip from './store/testdata/translate.ip'
import is from './store/testdata/translate.is'
import it from './store/testdata/translate.it'
import main from './store/testdata/translate.main'

Vue.use(Vuex)
Vue.use(VueContentPlaceholders)

export default new Vuex.Store({
  state: {
    footer,
    header,
    ip,
    is,
    it,
    main,
    lang: localStorage.getItem('lang') || 'ru'
  },
  mutations: {
    SET_LANG (state, data) {
      state.lang = data
      localStorage.setItem('lang', data)
    },
    MODIFY_TRANSLATE (state, data) {
      const {
        section,
        language,
        property,
        value
      } = data

      set(state, `${section}.${language}.${property}`, value)
    },
    SET_TEXTS (state, data) {
      state.footer = data.footer
      state.header = data.header
      state.ip = data.ip
      state.is = data.is
      state.it = data.it
      state.main = data.main
    }
  },
  modules: {

  }
})
